function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 0.8125C15.3125 0.8125 19.6875 5.1875 19.6875 10.5C19.6875 15.8516 15.3125 20.1875 10 20.1875C4.64844 20.1875 0.3125 15.8516 0.3125 10.5C0.3125 5.1875 4.64844 0.8125 10 0.8125ZM10 5.10938C9.0625 5.10938 8.35938 5.85156 8.35938 6.75C8.35938 7.6875 9.0625 8.39062 10 8.39062C10.8984 8.39062 11.6406 7.6875 11.6406 6.75C11.6406 5.85156 10.8984 5.10938 10 5.10938ZM12.1875 15.0312V14.0938C12.1875 13.8594 11.9531 13.625 11.7188 13.625H11.25V9.71875C11.25 9.48438 11.0156 9.25 10.7812 9.25H8.28125C8.00781 9.25 7.8125 9.48438 7.8125 9.71875V10.6562C7.8125 10.9297 8.00781 11.125 8.28125 11.125H8.75V13.625H8.28125C8.00781 13.625 7.8125 13.8594 7.8125 14.0938V15.0312C7.8125 15.3047 8.00781 15.5 8.28125 15.5H11.7188C11.9531 15.5 12.1875 15.3047 12.1875 15.0312Z",
  fill: "url(#paint0_linear_5049_5795)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear_5049_5795",
  x1: 0,
  y1: 10.1124,
  x2: 20,
  y2: 10.1124,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#4879C6"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#1E509D"
})));

var SvgIconInfo = function SvgIconInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-info.85a25d41.svg";
export { ForwardRef as ReactComponent };